



































































import {
  Component,
  Watch,
} from "@/shared/vuepack";
import { mixins } from "vue-class-component";
import {
  PersonaType,
  FundingOption
} from "@/shared/types";
import { ErrorsMixin } from "@/employer/components/shared/ErrorsMixin";
import Contribution from "@/employee/components/onboarding/Contribution.vue";
import ElectronicStatementConsent from "@/employee/components/onboarding/ElectronicStatementConsent.vue";
import ClaimContactInfo from "@/employee/components/claimAccountOnboarding/ClaimContactInfo.vue";
import { usePersonaStore } from "@/employee/store/persona";
import { useUserStore } from "@/shared/store/user";
import { useCustodianSettingsStore } from "@/shared/store/custodianSettings";

enum ClaimAccountPersonaSteps {
  None,
  Persona,
  ElectronicStatementConsent,
  Contribution,
  ContactInfo
}

@Component({
  components: {
    Contribution,
    ElectronicStatementConsent,
    ClaimContactInfo
  }
})
export default class ClaimAccountPersona extends mixins(ErrorsMixin) {

  personaStore = usePersonaStore();
  userStore = useUserStore();
  custodianSettingsStore = useCustodianSettingsStore();

  PersonaType = PersonaType;
  ClaimAccountPersonaSteps = ClaimAccountPersonaSteps;

  isSubmitting = false;
  isLoaded = false;
  isFormDirty = false;
  selectedPersonaType = PersonaType.None;
  componentIndex = 1;

  mounted () {
    this.personaStore.getPersonaType().catch(this.handleError);
    this.updateComponentState();
  }

  @Watch("personaStore.personaAndIsLoaded")
  updateComponentState () {
    if (this.personaStore.personaAndIsLoaded.isLoaded) {
      this.isLoaded = true;
      if (this.personaStore.personaAndIsLoaded.name === "pay") {
        this.selectedPersonaType = PersonaType.Pay;
        this.isFormDirty = true;
      } else if (this.personaStore.personaAndIsLoaded.name === "save") {
        this.selectedPersonaType = PersonaType.Save;
        this.isFormDirty = true;
      } else if (this.personaStore.personaAndIsLoaded.name === "invest") {
        this.selectedPersonaType = PersonaType.Invest;
        this.isFormDirty = true;
      } else {
        this.selectedPersonaType = PersonaType.None;
      }
    } else {
      this.isLoaded = false;
    }
  }

  get personaUnselected (): boolean {
    return this.selectedPersonaType === PersonaType.None;
  }

  get disableSubmit (): boolean {
    return this.personaUnselected || this.isSubmitting;
  }

  get canEditContributionView (): boolean {
    return this.userStore.employeeFundingOption === FundingOption.BendCalculatePull;
  }

  get canViewStatementPreference (): boolean {
    return this.userStore.isAutoEnrolled && this.custodianSettingsStore.custodianSupportsUserPreferences;
  }

  get canViewContactInfo (): boolean {
    // Elements uses SSO and accounts are created on their end
    return !this.custodianSettingsStore.isElementsCustodian;
  }

  get componentsForThisUser () {
    return [
      { allowed: true, step: ClaimAccountPersonaSteps.None },
      { allowed: true, step: ClaimAccountPersonaSteps.Persona },
      { allowed: this.canViewStatementPreference, step: ClaimAccountPersonaSteps.ElectronicStatementConsent },
      { allowed: this.canEditContributionView, step: ClaimAccountPersonaSteps.Contribution },
      { allowed: this.canViewContactInfo, step: ClaimAccountPersonaSteps.ContactInfo }
    ];
  }

  get currentStep (): ClaimAccountPersonaSteps {
    return this.componentsForThisUser[this.componentIndex].step;
  }

  stepComplete (): void {
    const indexOfNextStep = this.componentsForThisUser.findIndex(
        (el, index) => el.allowed && index > this.componentIndex);
    if (indexOfNextStep !== -1) {
      this.componentIndex = indexOfNextStep;
    } else {
      this.$emit("complete");
    }
  }

  submitPersonaType (event: any): void {
    if (!this.personaUnselected) {
      this.personaStore.setPersonaType(this.selectedPersonaType)
          .then(() => {
            this.isSubmitting = false;
          })
          .then(() => {
            this.stepComplete();
          })
          .catch(this.handleError);
    }
  }
}
